import gql from 'graphql-tag'

export const GET_COMPANY_IDLE_PARK_TIME = gql`
  query Company($filter: GetCompanyInput) {
    company(filter: $filter) {
      isSuccessful
      message
      company {
        idleTimeout
        parkTimeout
      }
    }
  }
`

export const UPDATE_COMPANY_IDLE_PARK_TIME = gql`
  mutation UpdateCompany($input: UpdateCompanyInput!) {
    updateCompany(input: $input) {
      isSuccessful
      message
    }
  }
`
